import { render } from "./JourneyEntry.vue?vue&type=template&id=281cb7c0&scoped=true&lang=pug"
import script from "./JourneyEntry.vue?vue&type=script&lang=ts"
export * from "./JourneyEntry.vue?vue&type=script&lang=ts"

import "./JourneyEntry.vue?vue&type=style&index=0&id=281cb7c0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-281cb7c0"

export default script